import { SensorStatusHelper } from '@/helpers/SensorStatusHelper';
import { TimeHelper } from '@/helpers/TimeHelper';
import { StatusMap, SubStatusMap } from '@/config/SensorStatuses';

const STATUS_NONE = 0
const STATUS_WORKSHOP = 1
const STATUS_READY = 2
const STATUS_OPERATIONAL = 4
const STATUS_DISCONNECTED = 5
const STATUS_CHECKED_OUT = 3
const STATUS_CHECKED_IN = 7
const STATUS_FAULT = 6
const STATUS_DECOMMISSIONED = 8


class SensorStatusModel {
  status
  subStatus
  note
  createdOn
  completedOn
  user

  constructor(data) {
    this.populate(data || {});
  }

    canManuallySwitchTo() {
        switch(this.status) {
            case 1:
                return [1,2,8]
            case 2:
                return [3]
            case 3:
                return [7]
            case 7:
                return [1,8]
            default:
                return []
        }
    }

    doesValidate() {
        if(this.subStatuses != null) {
            return this.subStatus != null
        }
        return true
    }

    get subStatuses() {
        // TODO DRY with statuses already defined elsewhere
        switch(this.status) {
            case 1:
                return {
                    11: 'Assembly',
                    12: 'Refurbishment',
                    13: 'Repair',
                    14: 'R&D',
                }
            case 3:
                return {
                    31: 'Packed',
                    32: 'Shipped',
                    33: 'With customer'
                }
            case 5:
                return {
                    51: 'Unknown',
                    52: 'Intentional',
                    53: 'Out of battery',
                    54: 'Damaged / destroyed',
                    55: 'Lost connectivity',
                    56: 'Stolen',
                }
            case 6:
                return {
                    61: 'GPS',
                    62: 'One sensor not working',
                }
            case 8:
                return {
                    81: 'Destroyed / recycled',
                    82: 'Faulty',
                    83: 'R&D',
                }
            default:
                return null
        }
    }

    get availableStatuses() {
        let output = {}
        // TMP all statuses are available to start with
        if(true || this.status == null || this.status == 5) {
            output = JSON.parse(JSON.stringify(StatusMap));
            delete output[0]
            return output
        }
        let allowedStatuses = this.canManuallySwitchTo()
        for(let key in StatusMap) {
            if(allowedStatuses.includes(parseInt(key))) output[key] = StatusMap[key]
        }
        return output
    }

    get statusName() {
        return this.status ? StatusMap[this.status] : 'No status'
    }

    get subStatusName() {
        return this.subStatus ? SubStatusMap[this.subStatus] : ''
    }

    get colour() {
        return SensorStatusHelper.getColour(this.status, this.subStatus)
    }

    get icon() {
        return SensorStatusHelper.getIcon(this.status, this.subStatus)
    }

    get description() {
        return SensorStatusHelper.getDescription(this)
    }

    get dateCreated() {
        return TimeHelper.formatDate(this.createdOn);
    }

    get dateCompleted() {
        return TimeHelper.formatDate(this.completedOn);
    }

  populate(data) {
    this.status = parseInt(data.status) || null;
    this.subStatus = parseInt(data.subStatus) || null;
    this.note = data.description || ''
    this.user = data.user || null
    this.createdOn = data.createdOn || null
    this.completedOn = data.completedOn || null
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    return output; // TODO first check if object is empty
  }

  exportToCreate() {
    return {
        status: this.status,
        subStatus: this.subStatus,
        description: this.note,
        userId: this.user.id,
        createdOn: TimeHelper.toSeconds(this.createdOn || Date.now()),
        completedOn: this.completedOn
    };
  }
}

export { SensorStatusModel };
